import { z } from 'zod';

import { AfcSubmissionCandidateSchema } from './afc-submission-candidate';
import { CandidateRateDiscountSchema } from './candidate-rate-discount';

export const InstantMatchSchema = z.object({
  calculatedRate: z.number().nullable(),
  candidate: AfcSubmissionCandidateSchema,
  candidateId: z.string(),
  opportunityId: z.string(),
  orderNumber: z.number().nullable(),
  passed: z.boolean(),
  pinnedByClient: z.boolean().default(false),
  rate: z.number(),
});

export type InstantMatch = z.infer<typeof InstantMatchSchema>;

export const InstantMatchesSchema = z.object({
  discount: CandidateRateDiscountSchema.nullable(),
  matches: z.array(InstantMatchSchema),
});

export type InstantMatches = z.infer<typeof InstantMatchesSchema>;
